// File: LocationDropdown.js
import React, { useEffect, useState } from 'react';
import axiosInstance from '../../../../api';

const LocationDropdown = ({ value, onChange }) => {
  const [locations, setLocations] = useState([]);

  useEffect(() => {
    const fetchLocations = async () => {
      try {
        const response = await axiosInstance.get('/locations');
        const locationData = response.data?.data || response.data || [];
        setLocations(locationData);
      } catch (error) {
        console.error('Error fetching locations:', error);
        alert('Failed to fetch locations');
      }
    };

    fetchLocations();
  }, []);

  return (
    <div className="mb-3">
      <select
  name="location_id"
  value={value}
  onChange={onChange}
  className="form-select"
>
  <option value="">Select Location</option>
  {locations.map((location) => (
    <option key={location.id} value={location.id}>
      {location.location_name}
    </option>
  ))}
</select>
    </div>
  );
};

export default LocationDropdown;
